import React from "react";

import { DropdownProps } from "semantic-ui-react";

import Cookies from "js-cookie";
import { IntlProvider } from "react-intl";

import { localizationEN, localizationTH } from "react-lib/localization/localization";

import { LocalizationContext, LocalizationContextType } from "./LocalizationContext";

type LocalizationWrapperState = {
  selectedLanguage: "en" | "th";
};

function getDisplayName(WrappedComponent: React.ComponentType<any>): string {
  return WrappedComponent.displayName || WrappedComponent.name || "Component";
}

const LocalizationWrapper = (WrappedComponent: React.ComponentType<any>) => {
  class LocalizationProvider extends React.Component<{}, LocalizationWrapperState> {
    static readonly displayName = `localizationWrapper(${getDisplayName(WrappedComponent)})`;

    #contextValue: LocalizationContextType | null = null;

    handleChangeLanguage = (e: React.SyntheticEvent<HTMLElement>, data: DropdownProps) => {
      const language = data.value as "en" | "th";

      this.setState({ selectedLanguage: language });
      Cookies.set("user_lang", language);
    };

    constructor(props: any) {
      super(props);
      this.state = { selectedLanguage: "en" };
    }

    componentDidMount(): void {
      let sysLang = Cookies.get("user_lang") || globalThis.navigator.language || "en-US";

      sysLang = sysLang.includes("th") ? "th" : "en";

      Cookies.set("user_lang", sysLang);
      this.setState({ selectedLanguage: sysLang as "en" | "th" });
    }

    getContextValue(): LocalizationContextType {
      if (
        !this.#contextValue ||
        this.#contextValue.selectedLanguage !== this.state.selectedLanguage
      ) {
        this.#contextValue = {
          handleChangeLanguage: this.handleChangeLanguage,
          selectedLanguage: this.state.selectedLanguage,
        };
      }

      return this.#contextValue;
    }

    render() {
      return (
        <IntlProvider
          locale={this.state.selectedLanguage}
          messages={this.state.selectedLanguage.includes("th") ? localizationTH : localizationEN}
        >
          <LocalizationContext.Provider value={this.getContextValue()}>
            <WrappedComponent
              userSelectedLanguage={this.state.selectedLanguage}
              onChangeLanguage={this.handleChangeLanguage}
            />
          </LocalizationContext.Provider>
        </IntlProvider>
      );
    }
  }

  return LocalizationProvider;
};

export default LocalizationWrapper;
